import { render, staticRenderFns } from "./home.vue?vue&type=template&id=087d42bb&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=087d42bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d42bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087d42bb')) {
      api.createRecord('087d42bb', component.options)
    } else {
      api.reload('087d42bb', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=087d42bb&scoped=true", function () {
      api.rerender('087d42bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/home.vue"
export default component.exports